import { render, staticRenderFns } from "./OfertsHotelPricesReduction.vue?vue&type=template&id=9faa3e40&scoped=true&"
import script from "./OfertsHotelPricesReduction.vue?vue&type=script&lang=js&"
export * from "./OfertsHotelPricesReduction.vue?vue&type=script&lang=js&"
import style0 from "./OfertsHotelPricesReduction.vue?vue&type=style&index=0&id=9faa3e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9faa3e40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VListItem,VListItemTitle,VRow,VSelect,VSwitch,VTextField,VTooltip})
